import { useMemo, useState } from "react"
import { errorMessages } from "../methods/validations"

export const useKinventController = () => {
    const [kinventData, setKinventData] = useState({})

    const handleKinventData = ({ target }) => {
        const { name, value } = target
        setKinventData(prev => ({ ...prev, [name]: value }))
    }

    const defaultData = (data = {}) => {
        setKinventData(data)
    }
    const validationKinvent = useMemo(() => {
        if (kinventData?.email || kinventData?.password) {
            const errors = errorMessages(kinventData)
            return { disabled: Object.values(errors)?.length > 0, errors }
        }

        return { disabled: false, errors: {} }
    }, [kinventData?.email, kinventData?.password])

    return {
        kinventData,
        validationKinvent,
        defaultData,
        handleKinventData
    }
}